import React from 'react';
import './RejectionNotesDrawer.css';
import closeIcon from "../../assets/images/closeIcon.svg";
import LoadingOverlay from '../loadingOverlay/LoadingOverlay';
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import BodySmallMedium from '../designSystem/BodySmallMedium';
import { IconButton } from '@mui/material';
import { t } from '../../locales/translate';

const RejectionNotesDrawer = ({ isOpen, onClose, rejectPlanDetails }) => {

    const isLoading = rejectPlanDetails === "isLoading";

    const notes = !isLoading && rejectPlanDetails && rejectPlanDetails.result ?
        rejectPlanDetails.result : [];
    
    const getInitials = (name) => {
        if (!name) return 'R';
        const nameParts = name.trim().split(' ');
        if (nameParts.length === 1) return nameParts[0].charAt(0).toUpperCase();
        return (nameParts[0].charAt(0) + nameParts[nameParts.length - 1].charAt(0)).toUpperCase();
    };

    return (
        <>

            <div className={`rejection-drawer-backdrop ${isOpen ? 'open' : ''}`} onClick={onClose}></div>

            <div className={`rejection-drawer-container ${isOpen ? 'open' : ''}`}>
                <LoadingOverlay isVisible={isLoading} />
                <div className="rejection-drawer-header">
                    <div className="header-left">
                        <div className="header-avatar-circle">
                            {notes.length > 0 ? getInitials(notes[0]?.rejectedByName) : 'R'}
                        </div>
                        <div className="header-title">
                            <BodyLargeMedium text={t("rejectionNotes")} />
                        </div>
                    </div>
                    <IconButton onClick={onClose}>
                        <img src={closeIcon} />
                    </IconButton>
                </div>

                <div className="rejection-drawer-content">
                    {notes.length > 0 ? (
                        notes.map((note, index) => (
                            <div key={index} className="rejection-note">
                                <div className="note-header">
                                    <div className="user-info">
                                        <BodyLargeMedium text={note.rejectedByName} />
                                    </div>
                                    <BodyExtraSmallMedium
                                        text={note.revisionDate
                                            ? new Date(note.revisionDate).toLocaleDateString('en-GB', {
                                                day: '2-digit',
                                                month: 'short',
                                                year: 'numeric'
                                            })
                                            : ''}
                                    />

                                </div>
                                <BodySmallMedium text={note.message || ''} />
                                <hr /> 
                            </div>
                        ))
                    ) : (
                        !isLoading && <div className="no-notes">{t("noRejectionNotes")}</div>
                    )}
                </div>
            </div>
        </>
    );
};

export default RejectionNotesDrawer;